import { render } from "./ProfileCalendar.vue?vue&type=template&id=5547746f"
import script from "./ProfileCalendar.vue?vue&type=script&lang=js"
export * from "./ProfileCalendar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__